export const sampleDrugData = [
  {
    drugName: "10MG",
    sequenceRange: "99997",
    depotName: "TestDepot",
    lotNumber: "Unbl Lot 11-24",
    labelGroupName: "TestLabel Test Edt",
    kitQuantity: 1,
    performedBy: "John Doe",
    protocol: "Protocol A",
    isApproved: false,
  },
  {
    drugName: "PBO",
    sequenceRange: "900",
    depotName: "Delhi Depot",
    lotNumber: "BLND099988",
    labelGroupName: "Control Group",
    kitQuantity: 1,
    performedBy: "Jane Smith",
    protocol: "Protocol B",
    isApproved: false,
  },
  {
    drugName: "10MG",
    sequenceRange: "99997",
    depotName: "Initial Depot",
    lotNumber: "Lot Test",
    labelGroupName: "Label Group One",
    kitQuantity: 1,
    performedBy: "Dr. Adams",
    protocol: "Protocol C",
    isApproved: false,
  },
  {
    drugName: "10MG",
    sequenceRange: "99997",
    depotName: "Initial Depot",
    lotNumber: "BLND099988",
    labelGroupName: "Label Group One",
    kitQuantity: 1,
    performedBy: "Mark Taylor",
    protocol: "Protocol C",
    isApproved: true,
  },
];

export const sampleBulkSiteData = [
  {
    id: 1,
    siteNumber: "10001",
    name: "Initial Site",
    active: true,
    drugOrdering: true,
    randomizationOpen: true,
    screeningOpen: true,
  },
  {
    id: 2,
    siteNumber: "10002",
    name: "Downtown Medical Center",
    active: false,
    drugOrdering: true,
    randomizationOpen: false,
    screeningOpen: true,
  },
  {
    id: 3,
    siteNumber: "10003",
    name: "Sunrise Clinic",
    active: true,
    drugOrdering: false,
    randomizationOpen: true,
    screeningOpen: false,
  },
  {
    id: 4,
    siteNumber: "10004",
    name: "Global Health Site",
    active: false,
    drugOrdering: false,
    randomizationOpen: false,
    screeningOpen: false,
  },
];

export const getDobAgeSelecterData = () => {
  let ages = [];
  for (let i = 1; i <= 100; i++) {
    ages.push({
      key: i,
      value: `${i}`,
    });
  }
  return ages;
};

export const depotData = [
  {
    id: 1,
    name: "Depot A",
  },
  {
    id: 2,
    name: "Depot B",
  },
  {
    id: 3,
    name: "Depot C",
  },
  {
    id: 4,
    name: "Depot D",
  },
];

export const lotDataForDrugOrder = [
  {
    id: 1,
    name: "Lot A",
  },
  {
    id: 2,
    name: "Lot B",
  },
  {
    id: 3,
    name: "Lot C",
  },
  {
    id: 4,
    name: "Lot D",
  },
  {
    id: 5,
    name: "Lot E",
  },
  {
    id: 6,
    name: "Lot F",
  },
  {
    id: 7,
    name: "Lot G",
  },
];

export const drugGridData = [
  {
    id: 1,
    orderNumber: 100001,
    source: "Depot - Initial Depot",
    destination: "Depot - India Depot",
    dateOrderRaised: "30-Dec-2024",
    dateOrderAcknowledge: "30-Dec-2024",
    isAcknowledge: false,
    isCancel: false,
  },
  {
    id: 2,
    orderNumber: 100002,
    source: "Depot - Delhi Depot",
    destination: "Depot - Mumbai Depot",
    dateOrderRaised: "02-Jan-2025",
    dateOrderAcknowledge: "03-Jan-2025",
    isAcknowledge: true,
    isCancel: false,
  },
  {
    id: 3,
    orderNumber: 100003,
    source: "Depot - Mumbai Depot",
    destination: "Depot - Chennai Depot",
    dateOrderRaised: "05-Jan-2025",
    dateOrderAcknowledge: "06-Jan-2025",
    isAcknowledge: false,
    isCancel: true,
  },
  {
    id: 4,
    orderNumber: 100004,
    source: "Depot - Chennai Depot",
    destination: "Depot - Bangalore Depot",
    dateOrderRaised: "10-Jan-2025",
    dateOrderAcknowledge: "11-Jan-2025",
    isAcknowledge: true,
    isCancel: false,
  },
  {
    id: 5,
    orderNumber: 100005,
    source: "Depot - Bangalore Depot",
    destination: "Depot - Hyderabad Depot",
    dateOrderRaised: "15-Jan-2025",
    dateOrderAcknowledge: "16-Jan-2025",
    isAcknowledge: false,
    isCancel: false,
  },
  {
    id: 6,
    orderNumber: 100006,
    source: "Depot - Hyderabad Depot",
    destination: "Depot - Pune Depot",
    dateOrderRaised: "20-Jan-2025",
    dateOrderAcknowledge: "21-Jan-2025",
    isAcknowledge: true,
    isCancel: false,
  },
  {
    id: 7,
    orderNumber: 100007,
    source: "Depot - Pune Depot",
    destination: "Depot - Kolkata Depot",
    dateOrderRaised: "25-Jan-2025",
    dateOrderAcknowledge: "26-Jan-2025",
    isAcknowledge: false,
    isCancel: true,
  },
  {
    id: 8,
    orderNumber: 100008,
    source: "Depot - Kolkata Depot",
    destination: "Depot - Initial Depot",
    dateOrderRaised: "30-Jan-2025",
    dateOrderAcknowledge: "31-Jan-2025",
    isAcknowledge: true,
    isCancel: false,
  },
];

export const shipperDemoData = [
  {
    id: "1",
    drugKitNumber: "A-000000399593 (Unit)",
    status: "In Transit",
    actions: ["Quarantined at Site", "Damaged", "Available At Site", "Expired"],
  },
  {
    id: "2",
    drugKitNumber: "A-000000399594 (Unit)",
    status: "In Transit",
    actions: ["Quarantined at Site", "Damaged"], // fewer buttons
  },
  {
    id: "3",
    drugKitNumber: "B-000000100513 (Unit)",
    status: "In Transit",
    actions: ["Damaged", "Expired"], // different set
  },
];

export const reconciliationData = Array.from({ length: 40 }, (_, i) => ({
  id: i + 1,
  drugKitNumber: "B-0000120120120",
  currentStatus: "Available At Site",
  packingType: "Unit",
  drugId: i + 1,
  statusText: "Available At Site",
}));

export const siteReturnToDepotActions = [
  {
    description: "Available At Site",
    enableAttributes: false,
    enablePillCount: true,
    id: "1b350a9e-5a70-496b-bc98-f0fecaf55168",
    notes: "",
    resupplyTreatAsAvailable: true,
    translationKey: "",
  },
  {
    description: "Damaged At Site",
    enableAttributes: false,
    enablePillCount: true,
    id: "1b350a9e-5a70-896b-bc98-f0fecaf55168",
    notes: "",
    resupplyTreatAsAvailable: true,
    translationKey: "",
  },
  {
    description: "Available At Depot",
    enableAttributes: false,
    enablePillCount: true,
    id: "1b350a9e-5870-496b-bc98-f0fecaf55168",
    notes: "",
    resupplyTreatAsAvailable: true,
    translationKey: "",
  },
];

export const demoDrugKitData = [
  {
    assignedDate: "2026-02-20",
    patientVisitDrugs: [
      {
        drugKitNumber: "DK-1023",
        drugStatus: "Dispensed",
        pillCount: 30,
        attributes: [
          { displayName: "Batch No", attributeValue: "B-221", displayOrder: 1 },
          {
            displayName: "Expiry Date",
            attributeValue: "Mar 2027",
            displayOrder: 2,
          },
        ],
      },
      {
        drugKitNumber: "DK-1024",
        drugStatus: "Returned",
        pillCount: 10,
        attributes: [
          { displayName: "Batch No", attributeValue: "B-500", displayOrder: 1 },
        ],
      },
    ],
  },
  {
    assignedDate: "2026-02-22",
    patientVisitDrugs: [
      {
        drugKitNumber: "DK-1100",
        drugStatus: "In Use",
        pillCount: 20,
        attributes: [
          {
            displayName: "Manufacturer",
            attributeValue: "Pfizer",
            displayOrder: 1,
          },
        ],
      },
    ],
  },
   {
    assignedDate: "2026-02-22",
    patientVisitDrugs: [
      {
        drugKitNumber: "DK-1100",
        drugStatus: "In Use",
        pillCount: 20,
        attributes: [
          {
            displayName: "Manufacturer",
            attributeValue: "Pfizer",
            displayOrder: 1,
          },
        ],
      },
    ],
  },
];
